/** OAuth storage key used by clients that attach their own bearer header. */
export const ACCESS_TOKEN_STORAGE_KEY = 'access_token'
